module.exports = __webpack_public_path__ + "img/ss2_glare.9f7fe503.png";